import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CTABanner from './components/CTABanner';
import QuemPodeSection from './components/QuemPodeSection';
import PorQueSection from './components/PorQueSection';
import EventoSection from './components/EventoSection';
import AutoridadeSection from './components/AutoridadeSection';
import HistoriasSection from './components/HistoriasSection';
import EtapaFinalSection from './components/EtapaFinalSection';
import UltimosVagasSection from './components/UltimosVagasSection';
import Footer from './components/Footer';
import StickyMobileCTA from './components/StickyMobileCTA';

const scrollTo = (_id: string) => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white pb-16 lg:pb-0">
      <Navbar onScrollTo={scrollTo} />
      <main>
        <HeroSection onScrollTo={scrollTo} />
        <CTABanner onScrollTo={scrollTo} />
        <QuemPodeSection />
        <PorQueSection />
        <EventoSection />
        <AutoridadeSection onScrollTo={scrollTo} />
        <HistoriasSection onScrollTo={scrollTo} />
        <EtapaFinalSection onScrollTo={scrollTo} />
        <UltimosVagasSection onScrollTo={scrollTo} />
      </main>
      <Footer />
      <StickyMobileCTA onScrollTo={scrollTo} />
    </div>
  );
}
